<template>
<div class="tasksMain" v-loading.fullscreen.lock="downLading">
  <div class="top_tabs" v-if="name == 1">
    <el-tabs v-model="activeNames"  stretch @tab-click="handleClickTop">
      <el-tab-pane label="All" name="first">
      </el-tab-pane>
      <el-tab-pane label="Quick match mode" name="second">
      </el-tab-pane>
    </el-tabs>
  </div>
  <div class="tasksTop">
    <div class="topSeach">
      <div class="innerSearch">
        <el-input placeholder="Search" v-model="input1" class="input-with-select" id="topInput">
          <el-select v-model="selects" slot="prepend" style="width: 100px">
            <el-option label="Invoice#" value="invoice#"></el-option>
            <el-option label="Task ID" value="task_id"></el-option>
            <el-option label="Contact" value="recipient_name"></el-option>
            <el-option label="Address" value="address"></el-option>
            <el-option label="Phone" value="phone"></el-option>
            <el-option label="Code" value="code"></el-option>
          </el-select>
        </el-input>
      </div>
      <div class="innerSearch">
        <el-select v-model="input2" placeholder="All">
          <el-option
            v-for="item in option"
            :key="item.worker_id"
            :label="item.name"
            :value="item.worker_id">
          </el-option>
            <div slot="prefix" >
              Drivers:
            </div>
          <div style="clear: both">
          </div>
        </el-select>
      </div>
      <div class="innerSearch ex">
        <el-select v-model="tagInput" placeholder="All">
          <el-option v-for="item in tagsOptions" :key="item.id" :label="item.tag_name" :value="item.id">
          </el-option>
          <div slot="prefix">Driver type:</div>
          <div style="clear: both"></div>
        </el-select>
      </div>
      <div class="innerSearch">
        <el-select v-model="groupInput" placeholder="All">
          <el-option
            v-for="item in gropuOption"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
          <div slot="prefix" >
            Groups:
          </div>
          <div style="clear: both">
          </div>
        </el-select>
      </div>
      <div class="innerSearch ex">
        <el-select v-model="typeInput" placeholder="All">
          <el-option
            v-for="item in typeOption"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
          <div slot="prefix" >
            Task types:
          </div>
          <div style="clear: both">
          </div>
        </el-select>
      </div>
      <div class="innerSearch cascader">
        <el-cascader v-model="selectStore" :props="props" v-if="name != 1"></el-cascader>
        <el-input v-model="store_input" placeholder="placeholder" disabled v-else></el-input>
        <div class="slot">Stores:</div>
      </div>
      <div class="innerSearch cascader">
        <div class="innerTime from">
          <el-date-picker
            v-model="time1"
            type="date"
            :clearable="false"
            placeholder="Select a date"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="chooseDate"
          >
          </el-date-picker>
          <div class="slot">Form:</div>
        </div>
      </div>
      <div class="innerSearch cascader">
        <div class="innerTime to">
          <el-date-picker
            v-model="time2"
            type="date"
            :clearable="false"
            placeholder="Select a date"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="chooseDate"
          >
          </el-date-picker>
          <div class="slot">To:</div>
        </div>
      </div>
      <div class="innerSearch">
        <el-select v-model="noteInput" placeholder="All">
          <el-option
            v-for="item in noteOption"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
          <div slot="prefix" >
            Notes:
          </div>
          <div style="clear: both">
          </div>
        </el-select>
      </div>

      <div class="innerSearch">
        <el-button type="success" round @click="seachHandle" style="width: 80px;padding: 0">Search</el-button>
        <el-button plain @click="clearAll" style="width: 80px" class="changeFocus">Clear</el-button>
      </div>
    </div>
  </div>
  <div class="tasksTable"  v-loading="loading" v-if="activeNames == 'first'">
    <div class="innerTop" style="position: relative;">
      <el-tabs v-model="activeName" @tab-click="handleClick" >
        <el-tab-pane v-for="(item,index) in tabsList" :key="index" :label="item.id == 'delaytask' ?  delaytask_title: item.label" :name="item.id">
            <div class="outTable"   v-if="anotherList.length!= 0">
            <div v-for="(i,v) in anotherList" :key="v">
              <div class="top">
                <div class="innerLeft">
                  <div>
                    <span class="titleColor">Task ID:</span>{{i.short_id}}
                  </div>
                  <div class="middleLine"></div>
                  <div class="middle">
                    <span class="titleColor">  Invoice#:
                    </span>{{i['invoice#']}}
                  </div>
                  <div class="middleLine"></div>
<!--                  <div style="margin-right: 6px">-->
<!--                    <span class="titleColor">  Task schedule:-->
<!--                    </span>{{i.schedule_desc}}-->
<!--                  </div>-->
                  <div class="third">
<!--                    <div>{{i.is_hub}}</div>-->
<!--                    <div>{{// i.is_pickup}}</div>-->
                    <div v-if="i.is_hub == '0'">
                      <div v-if="i.is_pickup == '0'"  style="display: flex">
                        <div class="pickup">Pickup</div>
                        <div class="yellow">Dropoff</div>
                      </div>
                      <div v-else-if="i.is_pickup == 1"  style="display: flex">
                        <div class="blues">Pickup</div>
<!--                        这里 drop off 应该为灰色-->
                        <div class="dropoff">Dropoff</div>
                      </div>
                    </div>

                    <div v-else-if="i.is_hub == '1'">
                      <div v-if="i.is_pickup == 0"  style="display: flex">
                        <div class="hub">Hub</div>
                        <div class="yellow">Dropoff</div>
                      </div>
                      <div v-else-if="i.is_pickup == 1"  style="display: flex">
                        <div class="blues">Pickup</div>
                        <div class="hubs">Hub</div>
                      </div>
                    </div>

                  </div>
                </div>
                <div><span class="titleColor">Created:</span> {{i.time}}</div>
              </div>
              <div class="btom">
                <div class="one all">
                  <div class="left">
                    <img src="../assets/image/car.png" alt="">
                  </div>
                  <div class="rights">
                    <div class="innerTop">
                      <div class="innerRed">
                        <img src="../assets/image/store@2x.png" alt="">
                      </div>
                      <div>{{i.create_by}}</div>
                      <div class="pickup_box" :style="{backgroundColor:i.pickup_status == 0?'#CCCCCC':'#1F2D42'}">
                        <img src="../assets/image/pickup.png" alt="">
                      </div>
<!--                      <div class="delay_no" v-if="i.is_delay == 1">-->
<!--                        Delayed-->
<!--                      </div>-->
                    </div>
                    <div class="innerBtom"> <span v-if="i.code!= ''">{{i.code}}</span> {{i.recipient_name}}</div>
                    <div class="innerBtom">{{i.address_desc}}</div>
                  </div>
                </div>
                <div class="two all"><span>{{i.worker_name}}</span></div>
                <div class="three all">
                  <div class="unassigned allIn" v-if="i.status == '0'">Unassigned</div>
                  <div class="assigned allIn"  v-if="i.status == '1'">Assigned</div>
                  <div class="completed allIn"  v-if="i.status == '3'">Completed</div>
                  <div class="transit allIn" v-if="i.status == '2'">In Transit</div>
                  <div class="failed allIn" v-if="i.status == '4'">Failed</div>
                  <div class="deleted allIn" v-if="i.status == '5'">Deleted</div>
                  <div style="cursor: pointer" @click="showDetial(i,'first')">View task</div>
                </div>
                <div class="four all">
                  <div class="red_right" v-if="i.is_note == 1"></div>
               <span @click="dialogVisible = true;id=i.id;delete_task_id = i.task_id" style="cursor: pointer" v-if="i.status == '0' || i.status == '1'">
              <img src="../assets/image/delete@2x.png" alt="">
              </span>
                  <span style="cursor: pointer" v-else>
              <img src="../assets/image/deleteNo.png" alt="">
              </span>
              <span @click="openEditDoalig(i,'edit')"  style="cursor: pointer" v-if="i.status == '0'|| i.status == '1'">
              <img src="../assets/image/edit@2x.png" alt="">
              </span>
                  <span  style="cursor: pointer" v-else>
              <img src="../assets/image/editNo.png" alt="">
              </span>
               <span @click="openEditDoalig(i,'clone')"  style="cursor: pointer">
              <img src="../assets/image/clone@2x.png" alt="">
              </span>
                  <span @click="showDetial(i,'second')"  style="cursor: pointer">
              <img src="../assets/tasks/mark@2x.png" alt="">
              </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="empty">
            <div>
              <img src="../assets/image/list_blank.png" alt="">
              <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
            </div>
          </div>
          <div class="btomPagin" >
            <div class="innerLeft">{{page}} - <span>{{anotherList.length}}</span> of <span>{{total}}</span> items</div>
            <div>
              <el-pagination
                :page-size="10"
                layout="prev, pager, next, jumper"
                :total="total"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- 是否超时显示标志 -->
      <div class="tabRightBox">
          <div class="tabContentImg" @click="exportTableHandle">
            <img src="../assets/export.png" alt="">
          </div>
          <el-button type="primary" round @click="onclickAddNewTask" style="margin-right: 16px">+NEW</el-button>
      </div>
    </div>
  </div>
  <div v-else>
    <quickMatch :send_message="send_message" ref="quick_match_box" @onClose="onCloseDiaog"></quickMatch>
  </div>
<!--  详情dialog-->
  <el-dialog
    :close-on-click-modal="false"
    custom-class="right"
    title="Task Details"
    :visible.sync="detialDialog"
    width="30%">
      <task-detial :info="info" ref="taskDetialRef" :show_tag="show_tag"></task-detial>
  </el-dialog>
<!--  删除弹框-->
  <el-dialog
    :close-on-click-modal="false"
    title=""
    :visible.sync="dialogVisible"
    width="30%">
    <div style="margin-top: 24px">The task will be permanently deleted.</div>
    <span slot="footer" class="dialog-footer">
         <el-button type="danger"  @click="dialogVisible = false" plain>Cancel</el-button>
    <el-button type="primary" @click="deleteTasks">Delete</el-button>
  </span>
  </el-dialog>
<!--  编辑弹框 或者复制-->
  <div v-if="outBox" class="changeTop">
    <el-dialog
      :close-on-click-modal="false"
      custom-class="noRadio"
      fullscreen
      :title="title"
      :visible.sync="editTaskDiog"
      :before-close="changeClose"
    >
      <add-new-tasks :title="title" :id="copyId" @closeDialog="closeDialog" :isReload="editTaskDiog"></add-new-tasks>
    </el-dialog>
  </div>
   <!-- 新增任务 start -->
   <el-dialog
      :close-on-click-modal="false"
      custom-class="noRadio"
      fullscreen
      :title="titleadd"
      :visible.sync="addNewTaskDiog"
      @close="clearDialog"
     >
      <div class="outSelect" v-if="showSelect">
        <div style="width: 1px;height: 20px ;background: #E0E0E0;margin-left: 24px;transform: translateY(6px)"></div>
        <div class="rightSelete">
          <div class="leftSelect ">
            <div class="innerLeft">
              <el-dropdown @command="changeStore" @visible-change="oneArrow = !oneArrow" trigger="click" placement="bottom-start">
        <span class="el-dropdown-link">
          <span style="margin-right: 3px;color: #000000">{{value1}}</span>
          <i class="el-icon-arrow-down el-icon--right" v-if="!oneArrow"></i>
          <i class="el-icon-arrow-up el-icon--right" v-if="oneArrow"></i>
        </span>
                <el-dropdown-menu slot="dropdown" class="changePosition">
                  <el-dropdown-item
                    v-for="item in options1"
                    :key="item.organization_id"
                    :command="item">
                    {{item.name}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div>
              <el-dropdown @command="changeStore2"  @visible-change="twoArrow = !twoArrow" trigger="click"  placement="bottom-start">
              <span class="el-dropdown-link">
                <span style="margin-right: 3px;color: #000000" v-if="value2!= ''">{{value2}}</span>
                <span style="margin-right: 3px;color: #CCCCCC" v-else>Select</span>
                <i class="el-icon-arrow-down el-icon--right" v-if="!twoArrow"></i>
                <i class="el-icon-arrow-up el-icon--right" v-if="twoArrow"></i>
              </span>
                <el-dropdown-menu slot="dropdown" class="changePosition" v-if="value2!= ''">
                  <el-dropdown-item
                    v-for="item in options2"
                    :key="item.organization_id"
                    :command="item"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
                <el-dropdown-menu slot="dropdown" class="changePosition" v-else>
                  <el-dropdown-item disabled>no data</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>

      <add-new-tasks v-if="addNewTaskDiog" ref="createTasks" :title="titleadd"  @closeDialog="addNewTaskDiog = false;$forceUpdate()"></add-new-tasks>
    </el-dialog>
   <!-- 新增任务 end -->
</div>
</template>

<script>
import quickMatch from "@/components/quickMatch";
import {deleteTaskList, getDriverList, getTasksList, tasksDetialList, scanTask, taskExport} from "@/api/tasks";
import addNewTasks from "@/components/addNewTasks";
import taskDetial from "@/components/taskDetial";
import EventBus from "@/ws/eventBus";
import {getGroupList, workerTagList} from "@/api/driver";
import {getOraList, getStoreList} from "@/api/organization";

import {getOrgaList, getSubOrgaList} from "@/api/addressBook";
import store from "@/store/index";

export default {
  name: "tasks",
  components:{
    addNewTasks,taskDetial,quickMatch
  },
  created() {
    //admin , worker , store , dispatch 0管理员 1门店 2派单员 3司机
    this.name = JSON.parse(localStorage.getItem("userInfo")).type;
    let label = localStorage.getItem('quick_label')
    if (this.name != 0){
      this.activeNames = label? label:'first'
    }else {
      this.activeNames = 'first'
    }
    if (localStorage.getItem('token')){
      this.getDriver()
      this.getTask()
      this.getDriverGroup()
    }else {
      this.$router.replace('/login')
    }
    if ( this.name == 0 ||  this.name == 2){
        this.showSelect = true
        this.gettopState()
    }
    this.delaytask_title = 'Upcoming  Late' + '（' + this.delay_task_data.count + '）'
    //获取司机类型
    this.getDriverType()

    //1. admin能看到所有的 (已有)
    //2. dispatcher能看到所支持的organization和store的
    //3. 门店只能看到自己的，并默认选中自己的

    //如果当前是门店 则需要在created 调用店铺数组 并且默认选中
    if (this.name == 1){
      // store_input
      getOraList({
        page:1,
        limit:100
      }).then(res => {
        getStoreList({
          page:1,
          id:res.data.data[0].id
        }).then(res=>{
          let store_id = JSON.parse(localStorage.getItem("userInfoDetail")).id;
          res.data.data.forEach(item=>{
             if (item.id == store_id){
               this.store_input = item.store_name
               this.store_input_id = item.id
             }
          })
        })
      })

    }
  },
  mounted() {
    // console.log(this.$route.path,'this.$route.path')
    EventBus.$on('autoCreate',(barCode)=>{
      if (this.activeNames == 'first'){
        this.autoCreate(barCode)
      }else {
        // console.log('jinlai le ',this.activeNames,this.$refs.quick_match_box.quickTaskDiog)
        if (this.$refs.quick_match_box.quickTaskDiog == true){
          this.$refs.quick_match_box.$refs.quick_match_add.scanQuickAdd(barCode)
        }else {
          this.$refs.quick_match_box.getQuickMatch(barCode)
        }
      }
    })
    EventBus.$on('updateTaskList',(msg)=>{
       this.getTask()
    })
    EventBus.$on('newTaskCome', (task) => {
      this.insertNewTaskToTop(task)
    })
  },
  data(){
    return{
      show_tag:'first',//显示哪个tag
      noteOption:[
        {name:"All",id:'all'},
        {name:"With a note",id:1},
        {name:"Without a note",id:0},
        {name:"COD order",id:2},
        {name:"Delivery delay",id:3},
        {name:"Customer complaint",id:4},
      ],
      noteInput:'all',
      downLading:false,//下载时的loading
      delete_task_id:'',
      send_message:{
        page:1,
        limit:10,
        keyword:'',
        keyvalue:'',
        worker_id:'',
        start_time:"",
        end_time:'',
        task_type:'',
      },//搜索如果是再快速扫码的页面，传给快速扫码列表
      name:'',
      activeNames:'first',
      //is_delay  0没有超时  1超时 all全部
      punList:[
        {name:'Delayed',id:'1'},
        {name:'Normal',id:'0'},
        {name:'All',id:'all'},
      ],
      punInput:'all',
      scheduleInput:'all',
      //schedule_type 1 1h 2 2h 3sd 4nd
      scheduleList:[
        {name:'Same Hour',id:'1'},
        {name:'2 Hour',id:'2'},
        {name:'Same Day',id:'3'},
        {name:'Next Day',id:'4'},
        {name:'All',id:'all'},
      ],
      info:'',
      scanFlage:true,
      outBox:false,
      copyId:'',
      title:"Edit Task",
      afterSacn:"",
      id:"",
      selects:'invoice#',
      input1:"",
      input2:"",
      input3:"",
      dialogVisible:false,
      editTaskDiog:true,
      activeName:"all",
      tabsList:[
        {label:'All',title:'All',id:'all'},
        {label:'Unassigned',title:'Unassigned',id:'0'},
        {label:'Assigned',title:'Assigned',id:'1'},
        {label:'In Transit',title:'In Transit',id:'2'},
        {label:'Completed',title:'Completed',id:'3'},
        {label:'Failed',title:'Failed',id:'4'},
        {label:'Deleted',title:'Deleted',id:'5'},
        {label:'Upcoming  Late',title:'Upcoming  Late',id:'delaytask'},
      ],
      delaytask_title:'',
      anotherList:[],
      detialDialog:false,
      activities: [],
      urls: [],
      options: [],
      option: [],
      value:"",
      page:1,
      limit:10,
      total:0,
      tasksId:'',
      loading:false,
      hasScanCodeList:[],
      typeOption:[
        {name:"All task types",id:'all'},
        {name:"Pickup",id:1},
        {name:"Dropoff",id:0},
        {name:"Pickup / Dropoff",id:2},
      ],//task type
      typeInput:'',
      groupInput:"",
      gropuOption:[],
      storeInput:'',
      storeOption:[],
      time1:"",
      time2:"",
      selectStore:"",
      props: {
        lazy: true,
        lazyLoad (node, resolve) {
          const { level } = node;
          setTimeout(async () => {
            if (node.level == 0){
              getOraList({
                page:1,
                limit:100
              }).then(res=>{
                if (res.code == 200){
                  const ora = res.data.data.map((value,i)=>({
                   value:value.id,
                   label:value.organization_name,
                    leaf: value.count ==0
                  }))
                  resolve(ora);
                }
              })
            }if (node.level == 1){
              getStoreList({
                page:1,
                id:node.value,
              }).then(res=>{
                const store = res.data.data.map((value,i)=>({
                  value:value.id,
                  label:value.store_name,
                  leaf:level >= 1
                }))
                resolve(store);
              })

            }
          },100);
        }
      },
      UpcomingLateNo:0,//是否超时的显示  任务数量

      addNewTaskDiog:false,
      showSelect:false,
      options1:[],
      options2:[],
      value1:"",
      value2:"",
      twoArrow:false,
      titleadd:'Create a New Task',
      tagInput:'',//司机类型
      tagsOptions:[],
      store_input:'',
      store_input_id:'',
    }
  },

  computed: {
    delay_task_data() {
      let a =  store.state.delyTaskData;
      this.UpcomingLateNo = a.count
      if(this.activeName == 'delaytask'){
        this.delaytask_title = 'Upcoming  Late' + '（' + a.count + '）'
        this.getTask2(a.data)
      }
      return a //store.state.delyTaskData;
    },
  },

  methods:{
    normalizeWsTaskForList(task) {
      if (!task || typeof task !== "object") return null;
      const invoiceValue = task["invoice#"] || task.invoice_number || "";
      const normalizedStatus = task.status !== undefined && task.status !== null ? String(task.status) : "0";
      const normalizedTask = {
        ...task,
        "invoice#": invoiceValue,
        short_id: task.short_id || task.task_id || "",
        worker_name: task.worker_name || task.worker || "",
        create_by: task.create_by || task.suffix || "",
        is_note: task.is_note !== undefined ? task.is_note : (task.is_notes || 0),
        status: normalizedStatus,
      };
      if (!normalizedTask.address_desc) {
        const unitText = normalizedTask.abs ? `,${normalizedTask.abs}` : "";
        normalizedTask.address_desc = `${normalizedTask.address || ""}${unitText}`;
      }
      return normalizedTask;
    },
    insertNewTaskToTop(task) {
      if (this.activeNames !== "first" || this.page !== 1) return;
      const normalizedTask = this.normalizeWsTaskForList(task);
      if (!normalizedTask || !normalizedTask.task_id) return;
      if (this.activeName !== "all" && String(this.activeName) !== String(normalizedTask.status)) return;
      const existsIndex = this.anotherList.findIndex(item => item.task_id === normalizedTask.task_id);
      if (existsIndex > -1) {
        this.anotherList.splice(existsIndex, 1);
      }
      this.anotherList.unshift(normalizedTask);
      if (this.anotherList.length > this.limit) {
        this.anotherList = this.anotherList.slice(0, this.limit);
      }
      if (typeof this.total === "number") {
        this.total += 1;
      }
    },
    getDriverType(){
      workerTagList({
        page: 1,
        // limit:0
      }).then((res) => {
        this.tagsOptions = res.data.data;
        this.tagsOptions.unshift({
          id: 0,
          tag_name: "No Driver type",
        });
      });
    },
    onCloseDiaog(){
      // console.log('---关闭快速任务窗口----');
      this.send_message = {
        page:1,
        limit:10,
        keyword:'',
        keyvalue:'',
        worker_id:'',
        start_time:"",
        end_time:'',
        task_type:'',
      }
    },

    //改变第一个值
    changeStore(val){
      this.value1 = val.name
      this.organization_id = val.organization_id
      this.getSubData()
    },
    //改变第二个值
    changeStore2(val){
        this.value2 =val.name
        this.$store.commit('changeStore',val.sub_organization_id)
    },
    //获取组织下拉数据
    gettopState(){
      getOrgaList().then(res=>{
        this.options1 = res.data
        this.value1 = res.data[0].name
        this.changeValue1 = res.data[0].name
        this.organization_id = res.data[0].organization_id
        this.getSubData()
      })
    },
    getSubData(){
      //获取门店下拉数据
      getSubOrgaList({
        organization_id:this.organization_id
      }).then(res=>{
        this.options2 = res.data
        if (res.data.length !=0){
          this.changeValue2 = res.data[0].name
          this.value2 = res.data[0].name
          this.$store.commit('changeStore',res.data[0].sub_organization_id)
        }else {
          this.value2 = ''
          this.$store.commit('changeStore','')
        }
      })
    },
    clearDialog(){
      this.$refs.createTasks.cancelAdd()
    },
    onclickAddNewTask(){
      // console.log('新增任务')
     this.addNewTaskDiog = true
    },
    chooseDate(){
      let t1 = this.time1
      let t2 = this.time2
      if (t1 && t2){
        if (new Date(t2).getTime()- new Date(t1).getTime()>= 360*1000*3600*24){
          this.$message({
            message: 'The number of days selected cannot exceed 360 days',
            type: 'warning',
          });
          this.time1 = ''
          this.time2 = ''
        }
      }
    },
    getDriverGroup(){
      getGroupList({
        order:'time desc',
        page:1,
        limit:''
      }).then(res=>{
       if (res.code == 200){
         this.gropuOption = res.data.data
       }
      })
    },
    autoCreate(barCode) {
      barCode =barCode.replace(/(\r\n|\r|\n)+/g, '')
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
      });
      // this.hasScanCodeList.push(barCode)
      // autoCreate 是判断是否是自动创建（0: 不自动创建，扫码之后将打开新建弹框，回填参数 1：自动创建 直接调用接口之后刷新列表）
      if (localStorage.getItem('autoCreate') == 0){
        //打开新建弹框
        loading.close()
        this.title = 'Create a New Task'
        this.outBox = true
        localStorage.setItem('barCode',barCode)
      }else {
        scanTask({
          data: barCode
        }).then((res) => {
          loading.close()
          if (res.code === 200) {
            EventBus.$emit('newTaskCome')
            this.$message({
              message: res.msg,
              type: 'success',
            });
            this.getTask();
          } else {
            this.$message({
              message: res.msg,
              type: 'warning',
            });
          }
        }).catch((error) => {
          this.submitLoading = false;
          this.$message({
            message: error.data.msg,
            type: 'warning',
          });
        });
      }
    },
    changeClose(done){
      this.outBox = false
    },
    deleteTasks(){
      deleteTaskList({
        id:this.id,
      }).then(res=>{
        this.getTask()
        if (res.code == 200){
          this.dialogVisible = false
          let currentScanTask = sessionStorage.getItem('currentScanTask')
          if (currentScanTask == this.delete_task_id){
            sessionStorage.setItem('currentScanTask','')
          }
          this.$message({
            message:res.msg,
            type: 'success'
          });
        }else {
          this.$message({
            message:res.msg,
            type: 'warning'
          });
        }
      }).catch(err=>{
        this.$message({
          message:err.msg,
          type: 'error'
        });
      })
    },
    openEditDoalig(i,type){
      this.copyId = i.id
      this.outBox = true
      if (type == 'edit'){
        this.title = 'Edit Task'
      }else {
        this.title = 'Copy Task'
      }
      // getCopyMssage({id:i.id}).then(res=>{
      //
      // })
    },
    getTask(){
      // console.log('==organization_id--',this.groupInput)
      this.loading = true
      let sub_id = this.selectStore[this.selectStore.length - 1]
      getTasksList({
        page:this.page,
        limit:this.limit,
        tab_status:this.activeName,
        keyword:this.selects,
        keyvalue:this.input1,
        worker_id:this.input2,
        start_time:this.time1,
        end_time:this.time2,
        task_type:this.typeInput,
        sub_organization_id:sub_id,
        is_delay:this.punInput,
        schedule_type:this.scheduleInput,
        organization_id:this.groupInput,
        tag_id:this.tagInput,
        has_note:this.noteInput
      }).then(res=>{
        this.loading = false
        this.anotherList = res.data.data
        this.total = res.data.count
      }).catch(err=>{
       this.loading = false
        this.$message({
          type: 'error',
          message: err.msg,
        });
      })
    },


    getTask2(taskids){
      // console.log('==organization_id--',this.groupInput)
      this.loading = true
      let sub_id = this.selectStore[this.selectStore.length - 1]
      getTasksList({
        page:this.page,
        limit:this.limit,
        // tab_status:this.activeName,
        keyword:this.selects,
        keyvalue:this.input1,
        worker_id:this.input2,
        start_time:this.time1,
        end_time:this.time2,
        task_type:this.typeInput,
        sub_organization_id:sub_id,
        is_delay:this.punInput,
        schedule_type:this.scheduleInput,
        organization_id:this.groupInput,
        delay_task:taskids,
        tag_id:this.tagInput,
        has_note:this.noteInput
      }).then(res=>{
        this.loading = false
        this.anotherList = res.data.data
        this.total = res.data.count
      }).catch(err=>{
       this.loading = false
        this.$message({
          type: 'error',
          message: err.msg,
        });
      })
    },

    handleCurrentChange(val){
      this.page = val
      if  (this.activeName == 'delaytask'){
        this.getTask2(this.delay_task_data.data)
      }else {
        this.getTask()
      }
    },
    getDriver(){
      getDriverList({token:localStorage.getItem('token')}).then(res=>{
        this.option = res.data
      })
    },
    seachHandle(){
      // console.log(this.activeName)
      if (this.activeNames == 'first'){
        this.page = 1
        this.getTask()
      }else {
        this.send_message = {
          page:this.page,
          limit:this.limit,
          tab_status:this.activeName,
          keyword:this.selects,
          keyvalue:this.input1,
          worker_id:this.input2,
          start_time:this.time1,
          end_time:this.time2,
          task_type:this.typeInput,
        }
        // console.log(this.send_message,'send_message')
      }
    },
    clearAll(){
      this.groupInput = ''
      this.input3 = ''
      this.input1 = ''
      this.input2 = ''
      this.selectStore = []
      this.typeInput = ''
      this.time2 = ''
      this.time1 = ''
      this.selects = 'invoice#'
      this.noteInput = 'all'
      this.getTask()
      this.send_message = {
        page:1,
        limit:10,
        keyword:'',
        keyvalue:'',
        worker_id:'',
        start_time:"",
        end_time:'',
        task_type:'',
      }
    },
    handleClick(tab, event){
      if (tab.index == '7'){
        this.activeName = 'delaytask'
        this.getTask2(this.delay_task_data.data)
      }else {
        this.activeName = tab.name
        this.page = 1
        this.getTask()
      }
    },

    handleClickTop(tab,event){
      //将点击后的label 存储在local 中 刷新后去local 中取
      localStorage.setItem('quick_label',tab.name)
      if(tab.name == 'first'){
        this.page = 1
        this.getTask()
      }
    },

    showDetial(i,e){
      if (i.status == 5){
        this.$message({
          type: 'error',
          message: 'This data has been deleted',
        });
      }else {
        this.info = i
        this.detialDialog = true
        this.show_tag = e
        console.log(this.show_tag,'ddd')
        setTimeout(()=>{
          this.$refs.taskDetialRef.getData()
      },100)
      }
    },
    closeDialog(){
      this.outBox = false
      this.$forceUpdate()
      this.getTask()
    },
    //导出
    exportTableHandle(){
      var sub_organization_id = ''
      if (this.name == 1){
        sub_organization_id = this.store_input_id
      }else {
        sub_organization_id = this.selectStore
      }
      if(this.isMoreThan30DaysApart(this.time1,this.time2) && sub_organization_id != ''){
        this.downLading = true
        taskExport({
          start_time:this.time1,
          end_time:this.time2,
          sub_organization_ids:sub_organization_id,
          worker_id:this.input2,
          invoice_number:this.input1
          // sub_organization_id:33,
        }).then(response=>{
          this.downLading = false
          // 创建一个 Blob 对象
          const blob = new Blob([response.data], { type: response.headers['content-type'] });

          // 创建一个临时 URL
          const url = window.URL.createObjectURL(blob);

          // 创建一个链接元素并触发下载
          const link = document.createElement('a');
          link.href = url;

          // 从响应头中获取文件名，如果没有则使用默认名称
          const filename = response.headers['content-disposition']
            ? response.headers['content-disposition'].split('filename=')[1]
            : 'download.xlsx';

          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();

          // 清理
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        })
      }else {
        this.$message({
          type: 'warning',
          message:'Please set the store and the start and end dates, with a maximum of 31 days supported.'
        })
      }
    },
    isMoreThan30DaysApart(dateString1, dateString2) {
      // 将日期字符串转换为 Date 对象
      const date1 = new Date(dateString1);
      const date2 = new Date(dateString2);

      // 计算两个日期之间的毫秒数差异
      const differenceInTime = Math.abs(date2 - date1);

      // 将毫秒转换为天数
      const differenceInDays = differenceInTime / (1000 * 3600 * 24);

      // 检查是否超过 31 天
      return differenceInDays < 31;
    }
  },
  destroyed(){
    EventBus.$off('autoCreate')
    EventBus.$off('newTaskCome')
   // EventBus.$off('updateTaskList')
  },
}
</script>

<style scoped lang="less">

.outSelect{
  display: flex;
  position: absolute;
  top: 35px;
  left: 180px;
  .rightSelete{
    display: flex;
  }
  .leftSelect{
    display: flex;
    line-height: 32px;
    margin-left: 24px;
    font-weight: bold;
    div{
      cursor: pointer;
    }
    .innerLeft{
      margin-right: 16px;
    }
  }

}


.tabRightBox{
      position: absolute;
      right: 0;
      top: -16px;
      // background-color: #32B0F8;
      // height: 38px;
      height:55px;
      z-index: 999;
      display: flex;
      flex-direction: row;
      align-items: center;
      .tabContentImg{
        margin-right: 32px;
        img{
          width: 22px;
          height: 22px;
          vertical-align: middle;
          cursor: pointer;
        }
      }
  }


// /deep/.el-tabs__nav-wrap{
//   background-color: #1472FF;
//   position: relative;
// }

.changeTop{
  /deep/ .el-dialog__header{
    padding: 32px 32px 24px 32px;
  }
}
.tasksMain{
/deep/ .el-dialog__headerbtn .el-dialog__close{
  color:#313131;
}
  .top_tabs{
    width: 322px;
    text-align: center;
    margin-bottom: 24px;
    /deep/.el-tabs__nav{
      background-color: #ECECF2!important;
      border-radius: 16px;
    }
    /deep/.el-tabs__header{
      margin: 0;
    }

    /deep/ .el-tabs__nav-scroll{
      padding-left: 0;
    }
    /deep/  .el-tabs__nav-wrap::after{
      background: none ;
    }
    /deep/  .el-tabs__item{
      height: 32px;
      line-height: 32px;
      flex: 1;
      padding-left: 0!important;
      padding-right: 0!important;
    }
    /deep/ .el-tabs__item.is-active{
      background: #E95646;
      color: #FFFFFF;
      border-radius: 16px;
    }
    /deep/.el-tabs__active-bar {
      background: none;
    }
  }

  .tasksTop{
    padding: 8px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #E0E0E0;
    display: flex;
    justify-content: space-between;
    /deep/.changeFocus:focus{
      border: 1px solid #DCDFE6;
      color: #606266;
    }
    .topSeach{
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      /deep/ .el-input--prefix .el-input__inner{
        padding-left: 88px;
      }
      /deep/ .el-input__prefix{
        color: #1F2D42;
      }
      .long_search{
        /deep/.el-input__inner{
          padding-left: 115px!important;
        }
      }
      .long_searchs{
        /deep/.el-input__inner{
          padding-left: 133px!important;
        }
      }
      .innerSearch{
     margin: 8px;
       /deep/.el-cascader{
         line-height: 0;
       }
      .innerTime{
        /deep/.el-input__prefix{
          position: absolute;
          top: 0;
          right: 12px;
          left: auto;
        }
        /deep/ .el-input--prefix .el-input__inner{
          padding-left: 12px;
        }
        /deep/.el-input__icon{
          //position: absolute;
          //right: 12px;
          color: #D65953;
        }
      }
       .from{
         /deep/.el-input__inner{
           padding-left: 75px!important;
         }
       }
       .to{
         /deep/.el-input__inner{
           padding-left: 55px!important;
         }
       }
     }
      .cascader{
        position: relative;
        /deep/.el-input__inner{
         padding-left: 80px;
        }
        .slot{
          position: absolute;
          padding-left: 24px;
          font-size: 14px;
          top: 5px;
        }
      }
      .ex{
        width: 300px;
        /deep/ .el-input--prefix .el-input__inner{
          padding-left: 110px;
        }
      }
    }

  }
  .third{
      display: flex;
      padding-right: 5px;
      color: #FFFFFF;
      height: 18px;
      line-height: 18px;
      margin-top: 8px;
      //background-color: #FFC215;
      font-size: 12px;
      border-radius: 4px;
      .hub{
        background-color: #1F2D42;
        border-radius: 4px;
        padding: 0 5px;
      }
      .pickup{
        background:#CCCCCC;
        padding: 0 5px;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        //margin-right: 5px;
      }
      //.blue{
      //  background:#1472FF;
      //  padding: 0 5px;
      //  border-top-right-radius: 4px;
      //  border-bottom-right-radius: 4px;
      //  //margin-right: 5px;
      //}
      .blues{
        background:#1472FF;
        padding: 0 9px 0 5px;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      .hubs{
        background-color: #1F2D42;
        border-radius: 4px;
        padding: 0 5px;
        margin-left: -4px;
      }
      .dropoff{
        background:#CDCCD1;
        padding: 0 5px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        //margin-right: 5px;
      }
      .yellow{
        padding: 0 5px;
        //margin-right: 5px;
        background: #FFC412;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        margin-left: -2px;
      }
    }
  .tasksTable{
    margin-top: 24px;
    font-weight: normal;
    font-size: 13px;

    .innerTop{
      .outTable{
        margin-top: 17px;
        //height: 58vh;
        //overflow: auto;
        .top{
          height: 32px;
          line-height: 32px;
          background: #ECECF2;
          border-radius: 16px 16px 0px 0px;
          border: 1px solid #E0E0E0;
          display: flex;
          justify-content: space-between;
          padding: 0 24px;
          .innerLeft{
            display: flex;
            .middle{
            }
            .middleLine{
              width: 1px;
              height: 16px;
              background-color:  #999999;
              margin: 8px 8px 0;
            }

          }
          .titleColor{
            color: #999999;
          }
        }
        .btom{
          //width: 1192px;
          height: 108px;
          background: #FFFFFF;
          border-radius: 0px 0px 16px 16px;
          border: 1px solid #E0E0E0;
          margin-bottom: 16px;
          display: flex;
          justify-content: flex-end;
          .all{
            padding: 16px 24px;
          }
          .one{
            border-right: 1px solid #E0E0E0;
            display: flex;
            width: 100%;
            .left{
              width: 60px;
              height: 60px;
              background: #1F2D42;
              border-radius: 8px;
              margin-top: 8px;
              img{
                margin-top: 15px;
              }
            }
            .rights{
              margin-left: 16px;
             .innerTop{
               display: flex;
               font-weight: bold;
               color: #1F2D42;
               font-size: 14px;
               line-height: 24px;
               .innerRed{
                 margin-right: 8px;
                 width: 24px;
                 height: 24px;
                 background: #E95646;
                 border-radius: 4px;
                 //vertical-align:middle;
                 img {
                   width: 15px;
                   margin-top: 4px;
                 }
               }
               .pickup_box{
                 width: 24px;
                 height: 24px;
                 border-radius: 50%;
                 margin-left: 15px;
                 img{
                   width: 11px;
                   height: 11px;
                 }
               }
               .delay_no{
               text-align: center;
                 color: #E95646;
                 width: 59px;
                 height: 24px;
                 border-radius: 12px;
                 border: 1px solid #E95646;
                 padding: 0 5px;
                 margin-left: 16px;
               }
             }
              .innerBtom{
                text-align: left;
                font-size: 13px;
                font-weight: 400;
                color: #999999;
                line-height: 20px;
                margin: 8px 0;
                height: 20px;
                overflow: hidden;
              }
            }
          }
          .two{
            width: 192px;
            border-right: 1px solid #E0E0E0;
            font-size: 14px;
            font-weight: 400;
            color: #1F2D42;
            position: relative;
            span{
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }
          .three{
            width: 156px;
            border-right: 1px solid #E0E0E0;
            padding-top: 20px;
           .allIn{
             //width: 108px;
             text-align: center;
             margin: 9px auto ;
             height: 22px;
             line-height: 22px;
             border-radius: 11px;
             font-size: 13px;
             font-weight: bold;
             color: #FFFFFF;
           }

          }
          .four{
            width: 130px;
            padding-top:45px;
            flex-shrink:0;
            position: relative;
            .red_right{
              position: absolute;
              top: 43px;
              right: 30px;
              width: 4px;
              height: 4px;
              background: #E95646;
              border-radius: 50%;
            }
            img{
              width: 16px;
              height: 16px;
              margin: 0 8px;
            }
          }
        }
      }
      .btomPagin{
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        padding-left: 16px;
        .innerLeft{
          font-size: 16px;
          font-family: SFPro-Regular, SFPro;
          font-weight: 400;
          color: #1F2D42;
          line-height: 20px;
        }
      }
    }
    .empty{
      width: 200px;
      height: 387px;
      margin: 20px auto;
      position: relative;
      img{
        width: 100%;
        height: 200px;
      }
      div{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .unassigned{
    background-color: #BCBEBF;
  }
  .assigned{
    background: #AB81F3;
    border-radius: 16px;
    padding: 0 12px;
    color: #FFFFFF;
    height: 32px;
    line-height: 32px;
    font-size: 13px;
    font-weight: bold;
  }
  .another{
    position: absolute;
    top: 27px;
    left: 140px;
  }
  .completed{
    background-color: #82D237;
  }
  .transit{
    background: #32B0F8;
    border-radius: 16px;
    padding: 0 12px;
    color: #FFFFFF;
    height: 32px;
    line-height: 32px;
    font-size: 13px;
    font-weight: bold;
  }
  .failed{
    background: #E95646;
  }
  .deleted{
    background: #1F2D42;
  }


}

</style>

